import React from 'react';

import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsCN } from './addressValidation';
import addressFields from './addressFieldMessages';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateField,
    PostalCodeField
} from './Fields';


export const AddressFieldsCN = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    useAddressAutocomplete,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.CN.street1Label,
        updateShippingAddress,
        useAddressAutocomplete,
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.CN.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.CN.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        label: addressFields.CN.stateLabel,
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        fieldType: 'tel',
        label: addressFields.CN.postalCodeLabel,
        normalize: null,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsCN.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsCN
};

AddressFieldsCN.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsCN;
